import './App.css'
import { useState, useEffect } from 'react'
import Navbar from './components/Navbar'
import Home from './components/Home'
import AboutView from './components/AboutView'
import MovieView from './components/MovieView'
import MissingPage from './components/MissingPage'
import { Routes, Route } from 'react-router-dom'
import SearchView from './components/SearchView'


// loading screen for when app first loads, on my phone the screen is white before the app pulls up. This is
// where a loading screen should be showing
//Pass setSearchResults props to SearchView, use the function to set the search results to results

function App() {
	const [searchResults, setSearchResults] = useState([])
	const [searchText, setSearchText] = useState('')

	//search bar functionality
	useEffect(() => {
		if (searchText) {
			// API request
			fetch(
				`https://api.themoviedb.org/3/search/movie?api_key=23f28c668f59a7895010a1481a3df51d&language=en-US&query=${searchText}&page=1&include_adult=false`
			)
				.then((response) => response.json())
				.then((data) => {
					// console.log(data);
					//set searchResults state
					setSearchResults(data.results)
				})
		}
		// dependency array, when search text changes run useEffect
	}, [searchText])

	return (
		<div>
			<Navbar
				searchText={searchText}
				setSearchText={setSearchText}
				searchResults={searchResults}
				setSearchResults={setSearchResults}
			/>
			<Routes>
				<Route path="*" text="text" element={<MissingPage />} />
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<AboutView />} />
				<Route
					path="/search"
					element={
						<SearchView keyword={searchText} searchResults={searchResults} />
					}
				/>
				<Route path="/movies/:id" element={<MovieView />} />
			</Routes>
		</div>
	)
}

export default App
